import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { InfoItemProps } from "../Info/Info";
import { ResearchChartDesktop } from "../ResearchChartDesktop/ResearchChartDesktop";
import { ResearchChartMobile } from "../ResearchChartMobile/ResearchChartMobile";

export const ResearchChart: React.FC = () => {
  const { t } = useTranslation("tour");
  const labels = t("ResearchChart") as Translations;
  const isDesktop = useMediaQuery({ query: bp.m });
  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <ResearchChartDesktop labels={labels} /> : <ResearchChartMobile labels={labels} />}
    </ChartContainer>
  );
};
